if (typeof ProductQuantity !== 'function') {

	class ProductQuantity extends HTMLElement {

			constructor() {

					super();
					if (this.querySelector('.qty-selector') != null) {
							const qty = this.querySelector('.qty-selector'),
									qtyMinus = this.querySelector('.qty-minus'),
									qtyPlus = this.querySelector('.qty-plus'),
									qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
									qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

							if (parseInt(qty.value) - 1 < qtyMin) {
									qtyMinus.classList.add('disabled');
							}
							if (parseInt(qty.value) + 1 > qtyMax) {
									qtyPlus?.classList.add('disabled');
							}

							qtyMinus.addEventListener('click', (e) => {
									e.preventDefault();
									if (!qtyMinus.classList.contains('disabled')) {
											const currentQty = parseInt(qty.value);
											if (currentQty - 1 >= qtyMin) {
													qty.value = currentQty - 1;
													qtyPlus?.classList.remove('disabled');
											}
											if (currentQty - 1 <= qtyMin) {
													qtyMinus.classList.add('disabled');
											}
									}
							});

							qtyPlus?.addEventListener('click', (e) => {
									e.preventDefault();
									let checkQtyMax;
									if (this.hasAttribute('data-js-product-quantity')) {
											checkQtyMax = parseInt(document.querySelector('[data-js-product-form]').getAttribute('data-limit-location'));
									} else {
											checkQtyMax = qtyMax
									}

									if (!qtyPlus?.classList.contains('disabled')) {
											const currentQty = parseInt(qty.value);
											if (currentQty + 1 <= checkQtyMax) {
													qty.value = currentQty + 1;
													qtyMinus.classList.remove('disabled');
											}
											if (currentQty + 1 >= checkQtyMax) {
													qtyPlus?.classList.add('disabled');
											}
									}
							});

							qty.addEventListener('change', (e) => {
								e.preventDefault();
								let checkQtyMax;
								if (this.hasAttribute('data-js-product-quantity')) {
										checkQtyMax = parseInt(document.querySelector('[data-js-product-form]').getAttribute('data-limit-location'));
								} else {
										checkQtyMax = qtyMax
								}
								const currentQty = parseInt(qty.value);
								if (currentQty >= checkQtyMax) {
									qty.value = checkQtyMax;
									qtyMinus.classList.remove('disabled');
									qtyPlus?.classList.add('disabled');
								}

								if (currentQty < qtyMin + 1) {
									qtyMinus.classList.add('disabled');
									qtyPlus?.classList.remove('disabled');
								}
						});
					}

			}

	}

	if (typeof customElements.get('product-quantity') == 'undefined') {
			customElements.define('product-quantity', ProductQuantity);
	}

}
